import React from 'react';

const WhatsappLink: React.FC = () => {
  return (
    <a
      href="https://api.whatsapp.com/send?phone=85269000755"
      target="_blank"
      rel="noreferrer"
    >
      +85269000755
    </a>
  );
};

export default WhatsappLink;
